export default {
  openGraph: {
    type: 'website',
    locale: 'en_GB',
    url: 'https://www.modellink.se',
    site_name: 'Modellink',
  },
}
